import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { userContext } from "../context/UserContext";
import { api_url } from "../helpers";

const Checkout = () => {
  const [selectedPayment, setSelectedPayment] = useState("payment1");
  const { cart, user, setLoad } = useContext(userContext);
  const [branch, setBranch] = useState("");
  const [pincode, setPincode] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [city, setCity] = useState("");
  const [note, setNote] = useState("");
  const [addresses, setAdresses] = useState([]);
  const [shippingName, setShippingName] = useState("");

  const handlePaymentChange = (event) => {
    setSelectedPayment(event.target.id);
  };

  async function HandleSubmit(e) {
    e.preventDefault();

    if (shippingName) {
      createOrder(shippingName);
    } else {
      let send_data = {
        data: {
          name: branch,
          address_title: branch,
          address_type: "Shipping",
          address_line1: addressLine1,
          address_line2: addressLine2,
          city: city,
          country: "Kuwait",
          longitude: "",
          latitude: "",
          pincode: pincode,
          is_primary_address: 0,
          is_shipping_address: 0,
          links: [
            {
              link_doctype: "Customer",
              link_name: user?.customer_id,
              link_title: user?.customer_id,
            },
          ],
        },
      };

      const response = await fetch(api_url + "resource/Address", {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(send_data),
        method: "POST",
      });

      const data = await response.json();

      console.log(data);

      if (data?.data?.name) {
        // address created successfully
        setShippingName(data?.data?.name);
        createOrder(data?.data?.name);
      }
    }
  }

  async function createOrder(address_name) {
    const draftResponse = await fetch(
      api_url + `resource/Sales Order/${cart?.sales_order}?run_method=submit`,
      {
        method : 'POST',
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
          "Content-Type" : "application/json"
        },
        body : JSON.stringify({
          "run_method" : "submit"
        })
      }
    );

    const draftData = await draftResponse.json();

    console.log(draftData);

    if (draftData?.data?.name) {
      const response = await fetch(
        api_url +
          "method/erp_sn.api.create_sales_invoice.create_sales_invoice_from_sales_order",
        {
          method: "POST",
          headers: {
            Authorization: `token ${user?.api_key}:${user?.api_secret}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            sales_order: cart?.sales_order,
          }),
        }
      );

      const data = await response.json();

      console.log('set',data)

      if (data?.message?.name){
        linkAddressToInvoice(data?.message?.name,address_name)
      }
    }

  }

  async function linkAddressToInvoice(sales_invoice,address_name) {
    setLoad(true)

    const response = await fetch(api_url + `resource/Sales Invoice/${sales_invoice}`,{
      method : 'PUT',
      headers : {
        "Authorization" : `token ${user?.api_key}:${user?.api_secret}`,
        "Content-Type" : "application/json"
      },
      body : JSON.stringify({
        "shipping_address": address_name
      })
    })

    const data = await response.json()

    if (data?.data?.name){
      window.location.pathname = '/ordersuccess'
    }

    setTimeout(() => {
      setLoad(false)
    }, 300);
  }

  async function fetchAddress() {
    const fields = JSON.stringify(["*"]);
    const filters = JSON.stringify([
      ["Dynamic Link", "link_name", "like", user?.customer_id],
    ]);
    const responsData = await fetch(
      api_url +
        `resource/Address?fields=${encodeURIComponent(
          fields
        )}&limit_page_length=20&limit_start=0&filters=${encodeURIComponent(
          filters
        )}`,
      {
        headers: {
          Authorization: `token ${user?.api_key}:${user?.api_secret}`,
        },
      }
    );

    if (responsData.ok == true) {
      const data = await responsData.json();

      if (data?.data?.length > 0) {
        setAdresses(data?.data);
      }
    }
  }

  useEffect(() => {
    fetchAddress();
  }, []);

  return (
    <section className="checkout py-80">
      <div className="container container-lg">
        {/* <div className="border border-gray-100 rounded-8 px-30 py-20 mb-40">
          <span className="">
            Have a coupon?{" "}
            <Link
              to="/cart"
              className="fw-semibold text-gray-900 hover-text-decoration-underline hover-text-main-600"
            >
              Click here to enter your code
            </Link>{" "}
          </span>
        </div> */}

        <div className="row">
          <div className="col-xl-9 col-lg-8 mb-30">
            <div className="px-12 d-lg-flex">
              {addresses?.length > 0 &&
                addresses?.map((item, index) => (
                  <div
                    className="ms-auto me-auto checkout-right-side-location"
                    key={index}
                  >
                    <h6 className="mb-1 p-0 fs-5">{item?.address_title}</h6>
                    <p className="p-0 m-0">
                      {item?.address_line1}
                      {item?.address_line2}
                    </p>
                    <p className="p-0 m-0">City: {item?.city}</p>
                    <p className="p-0 mb-7">Pincode : &nbsp; {item?.pincode}</p>

                    <button
                      onClick={() => {
                        console.log(item);
                        setShippingName(item?.name);
                        setBranch(item?.address_title);
                        setPincode(item?.pincode);
                        setAddressLine1(item?.address_line1);
                        setAddressLine2(item?.address_line2);
                        setCity(item?.city);
                      }}
                      className="btn btn-main py-18 rounded-8 mt-40"
                    >
                      Use This Address
                    </button>
                  </div>
                ))}
            </div>
            <form
              action="#"
              className="mb-30 "
              onSubmit={(e) => HandleSubmit(e)}
            >
              <div className="row gy-3">
                <div className="col-sm-6 col-xs-6">
                  <input
                    type="text"
                    className="common-input border-gray-100"
                    placeholder="Branch Name"
                    required
                    value={branch}
                    onChange={(e) => setBranch(e.target.value)}
                  />
                </div>
                <div className="col-sm-6 col-xs-6">
                  <input
                    type="text"
                    className="common-input border-gray-100"
                    placeholder="Pincode"
                    required
                    value={pincode}
                    onChange={(e) => setPincode(e.target.value)}
                  />
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    className="common-input border-gray-100"
                    placeholder="Address Line 1"
                    required
                    value={addressLine1}
                    onChange={(e) => setAddressLine1(e.target.value)}
                  />
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    className="common-input border-gray-100"
                    placeholder="Address Line 2"
                    required
                    value={addressLine2}
                    onChange={(e) => setAddressLine2(e.target.value)}
                  />
                </div>

                <div className="col-12">
                  <input
                    type="text"
                    className="common-input border-gray-100"
                    placeholder="City"
                    required
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </div>

                {/* <div className="col-12">
                  <div className="my-40">
                    <h6 className="text-lg mb-24">Additional Information</h6>
                    <input
                      type="text"
                      className="common-input border-gray-100"
                      placeholder="Notes about your order, e.g. special notes for delivery."
                      required
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                    />
                  </div>
                </div> */}
              </div>

              <button type="submit" className="d-none" id="address-form-btn">
                Submit
              </button>
            </form>
          </div>
          <div className="col-xl-3 col-lg-4">
            <div className="checkout-sidebar">
              <div className="bg-color-three rounded-8 p-24 text-center">
                <span className="text-gray-900 text-xl fw-semibold">
                  Your Orders
                </span>
              </div>
              <div className="border border-gray-100 rounded-8 px-24 py-40 mt-24">
                <div className="mb-32 pb-32 border-bottom border-gray-100 flex-between gap-8">
                  <span className="text-gray-900 fw-medium text-xl font-heading-two">
                    Product
                  </span>
                  <span className="text-gray-900 fw-medium text-xl font-heading-two">
                    Rate
                  </span>
                </div>
                {cart?.items?.length > 0 &&
                  cart?.items?.map((item, index) => (
                    <div className="flex-between gap-24 mb-32" key={index}>
                      <div className="flex-align gap-12">
                        <span className="text-gray-900 fw-normal text-md font-heading-two w-144">
                          {item?.item_name}
                        </span>
                        <span className="text-gray-900 fw-normal text-md font-heading-two">
                          <i className="ph-bold ph-x" />
                        </span>
                        <span className="text-gray-900 fw-semibold text-md font-heading-two">
                          {item?.qty}
                        </span>
                      </div>
                      <span className="text-gray-900 fw-bold text-md font-heading-two">
                        {item?.rate} KD
                      </span>
                    </div>
                  ))}

                <div className="border-top border-gray-100 pt-30  mt-30">
                  <div className="mb-32 flex-between gap-8">
                    <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                      Subtotal
                    </span>
                    <span className="text-gray-900 font-heading-two text-md fw-bold">
                      {cart?.items?.reduce(
                        (sum, item) =>
                          sum + parseFloat(item?.qty) * parseFloat(item?.rate),
                        0
                      )}{" "}
                      KD
                    </span>
                  </div>
                  <div className="mb-0 flex-between gap-8">
                    <span className="text-gray-900 font-heading-two text-xl fw-semibold">
                      Total
                    </span>
                    <span className="text-gray-900 font-heading-two text-md fw-bold">
                      {cart?.items?.reduce(
                        (sum, item) =>
                          sum + parseFloat(item?.qty) * parseFloat(item?.rate),
                        0
                      )}{" "}
                      KD
                    </span>
                  </div>
                </div>
              </div>
              <div className="mt-32">
                <div className="payment-item">
                  <div className="form-check common-check common-radio py-16 mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="payment"
                      id="payment1"
                      checked={selectedPayment === "payment1"}
                      onChange={handlePaymentChange}
                    />
                    <label
                      className="form-check-label fw-semibold text-neutral-600"
                      htmlFor="payment1"
                    >
                      Direct Bank transfer
                    </label>
                  </div>
                  {selectedPayment === "payment1" && (
                    <div className="payment-item__content px-16 py-24 rounded-8 bg-main-50 position-relative d-block">
                      <p className="text-gray-800">
                        Make your payment directly into our bank account. Please
                        use your Order ID as the payment reference. Your order
                        will not be shipped until the funds have cleared in our
                        account.
                      </p>
                    </div>
                  )}
                </div>
                <div className="payment-item">
                  <div className="form-check common-check common-radio py-16 mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="payment"
                      id="payment2"
                      checked={selectedPayment === "payment2"}
                      onChange={handlePaymentChange}
                    />
                    <label
                      className="form-check-label fw-semibold text-neutral-600"
                      htmlFor="payment2"
                    >
                      Check payments
                    </label>
                  </div>
                  {selectedPayment === "payment2" && (
                    <div className="payment-item__content px-16 py-24 rounded-8 bg-main-50 position-relative d-block">
                      <p className="text-gray-800">
                        Make your payment directly into our bank account. Please
                        use your Order ID as the payment reference. Your order
                        will not be shipped until the funds have cleared in our
                        account.
                      </p>
                    </div>
                  )}
                </div>
                <div className="payment-item">
                  <div className="form-check common-check common-radio py-16 mb-0">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="payment"
                      id="payment3"
                      checked={selectedPayment === "payment3"}
                      onChange={handlePaymentChange}
                    />
                    <label
                      className="form-check-label fw-semibold text-neutral-600"
                      htmlFor="payment3"
                    >
                      Cash on delivery
                    </label>
                  </div>
                  {selectedPayment === "payment3" && (
                    <div className="payment-item__content px-16 py-24 rounded-8 bg-main-50 position-relative d-block">
                      <p className="text-gray-800">
                        Make your payment directly into our bank account. Please
                        use your Order ID as the payment reference. Your order
                        will not be shipped until the funds have cleared in our
                        account.
                      </p>
                    </div>
                  )}
                </div>
              </div>
              <div className="mt-32 pt-32 border-top border-gray-100">
                <p className="text-gray-500">
                  Your personal data will be used to process your order, support
                  your experience throughout this website, and for other
                  purposes described in our{" "}
                  <Link
                    to="#"
                    className="text-main-600 text-decoration-underline"
                  >
                    {" "}
                    privacy policy
                  </Link>{" "}
                  .
                </p>
              </div>
              <button
                onClick={() =>
                  document.getElementById("address-form-btn").click()
                }
                className="btn btn-main mt-40 py-18 w-100 rounded-8 mt-56"
              >
                Place Order
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Checkout;
